/**
 * Эмодзи из названий категорий: бренд ставит их прямо в CRM («🍔 Бургеры»,
 * «🍕Большие пиццы»), причём то через пробел, то без. Вырезаем сам символ
 * и схлопываем пробелы, иначе остаются рваные отступы и хвосты.
 */
const EMOJI = /[\p{Extended_Pictographic}\u{FE0F}\u{200D}]/gu

export function stripEmoji(value: string): string {
  return value.replace(EMOJI, '').replace(/\s+/g, ' ').trim()
}
